import { useResetRecoilState } from "recoil";
import {
  analysisDocumentLevelState,
  analysisFormStepState,
  selectedAnalysisBusinessTagState,
  selectedAnalysisCityState,
  selectedAnalysisProvinceState,
} from "store/document/analysisDocument";

const useResetAnalysisDocStates = () => {
  const resetAnalysisFormStep = useResetRecoilState(analysisFormStepState);
  const resetSelectedProvince = useResetRecoilState(
    selectedAnalysisProvinceState,
  );
  const resetSelectedCity = useResetRecoilState(selectedAnalysisCityState);
  const resetSelectedBusinessTag = useResetRecoilState(
    selectedAnalysisBusinessTagState,
  );
  const resetAnalysisLevel = useResetRecoilState(analysisDocumentLevelState);

  const resetAnalysisDocStates = () => {
    resetAnalysisFormStep();
    resetSelectedProvince();
    resetSelectedCity();
    resetSelectedBusinessTag();
    resetAnalysisLevel();
  };

  return {
    resetAnalysisDocStates,
  };
};

export default useResetAnalysisDocStates;
